const React = require('react');
const {AdminInput} = require('../../../../../../FormInputs');
const PersonFields = require('../../../PersonFields');

module.exports = ({activeUserId, formCtx}) => {
  return (
    <PersonFields
      docsPrefix="owner"
      activeUserId={activeUserId}
      formCtx={formCtx}
      lastField={(
        <AdminInput
          name="owner_percent"
          label="% of shares"
          formCtx={formCtx}
        />
      )}
    />
  )
}
